import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** SLA color class for 1-day reporting (target: 95%) */
export function sla1dColorClass(value: number | null): string {
  if (value === null) return 'text-muted-foreground';
  if (value >= 95) return 'text-green-600';
  return 'text-red-600';
}

/** SLA color class for 3-day reporting (target: 97%, warning at 95%) */
export function sla3dColorClass(value: number | null): string {
  if (value === null) return 'text-muted-foreground';
  if (value >= 97) return 'text-green-600';
  if (value >= 95) return 'text-yellow-600';
  return 'text-red-600';
}

/**
 * Format waterscope sensor group type for display
 * Converts "Profile" to "Billing Profile" for clarity
 */
export function formatWaterscopeGroupType(type: string | null): string | null {
  if (type === 'Profile') {
    return 'Billing Profile';
  }
  return type;
}
